import { cva } from 'class-variance-authority';
import { type PropsWithChildren } from 'react';

import ClearIcon from '@/assets/svg/bx-x.svg?react';
import { Button } from '@/components/buttons';
import { Text } from '@/components/typography';
import { cn } from '@/lib/utils';

const notificationVariants = cva('flex flex-row items-center gap-3 px-8', {
  variants: {
    type: {
      default: 'bg-gray-400',
      success: 'bg-green-100',
      error: 'bg-red-400 text-white [&_a]:text-white',
      info: 'bg-aqua-400 text-white [&_a]:text-white',
    },
    size: {
      medium: 'py-1.25',
      large: 'py-3.75',
    },
  },
  defaultVariants: {
    type: 'default',
    size: 'medium',
  },
});

type Props = {
  className?: string;
  type?: 'default' | 'success' | 'error' | 'info';
  size?: 'medium' | 'large';
  onClose?: () => void;
};

const Notification = ({
  className,
  type = 'default',
  size = 'medium',
  onClose,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <div data-testid="notification" className={cn(notificationVariants({ type, size }), className)}>
      <Text className="flex-1 wrap-break-word text-inherit" variant="caption1" weight="semi-bold">
        {children}
      </Text>
      {onClose && (
        <Button
          variant="ghost"
          inverse={type === 'error' || type === 'info'}
          size="icon-small"
          onClick={onClose}
        >
          <ClearIcon />
        </Button>
      )}
    </div>
  );
};

export default Notification;
